import { useEffect, useState } from 'react';

import { ExploreBlockSummary } from '@addmile/backend-client';

import { GetBlockParams } from '../BlockList/BlockFilters';

export const useFilteredSortedBlocks = (
  items: ExploreBlockSummary[] | undefined,
  filters: GetBlockParams,
) => {
  const [orderedBlocks, setOrderedBlocks] = useState<ExploreBlockSummary[]>([]);

  useEffect(() => {
    if (!items) {
      setOrderedBlocks([]);
      return;
    }

    const filtered =
      items
        .map((b) => ({
          ...b,
          showFeedback: false,
          position: b.position ?? 0,
        }))
        .filter((block) => {
          if (filters.title && !block.title.toLowerCase().includes(filters.title.toLowerCase())) {
            return false;
          }
          if (filters.type && filters.type.length > 0 && !filters.type.includes(block.type)) {
            return false;
          }
          if (filters.language && block.language !== filters.language) {
            return false;
          }
          if (
            filters.status &&
            filters.status.length > 0 &&
            !filters.status.includes(block.status)
          ) {
            return false;
          }
          return true;
        }) || [];

    setOrderedBlocks(filtered);
  }, [items, filters]);

  return { orderedBlocks, setOrderedBlocks };
};
